import { Component, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-challenges-page',
  templateUrl: './challenges-page.component.html',
  styleUrls: ['./challenges-page.component.scss'],
})
export class ChallengesPageComponent implements OnInit {
  screenType = ScreenType;
  constructor() {}

  ngOnInit(): void {}
}
